import { useGetUrlSearchParam } from '../../../../core/hooks/useGetUrlParam'
import useGetCompanyForms from './useGetCompanyForms'

export const useGetCompanyFormsWithTypes = (publish?: boolean) => {
  const searchedTags = useGetUrlSearchParam('types')
  return useGetCompanyForms({ publish, types: searchedTags?.split(',') })
}

export default useGetCompanyFormsWithTypes
